import { render, staticRenderFns } from "./pesoVolumetrico.vue?vue&type=template&id=44cfb0a8&scoped=true&"
import script from "./pesoVolumetrico.vue?vue&type=script&lang=js&"
export * from "./pesoVolumetrico.vue?vue&type=script&lang=js&"
import style0 from "./pesoVolumetrico.vue?vue&type=style&index=0&id=44cfb0a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cfb0a8",
  null
  
)

export default component.exports